import React from "react";

export default function LogoBig({ fontColor = "#000000", crossColor = "#CE003B", ...props } = {}) {
	return <div className="logo logo-big" {...props}>
		<svg version="1.1" id="Layer_1" x="0px" y="0px"
			viewBox="0 0 1000 175" space="preserve">
			<path style={{
				fill: fontColor
			}} d="M12.7,161.8C4.2,153.4,0,142.3,0,128.5v-81c0-13.8,4.2-24.9,12.7-33.3C21.1,5.9,32.2,1.7,46,1.7c13.8,0,25,4.2,33.5,12.5
	c8.5,8.4,12.8,19.4,12.8,33.3v81c0,13.8-4.3,24.9-12.8,33.3c-8.5,8.4-19.7,12.5-33.5,12.5C32.2,174.3,21.1,170.1,12.7,161.8
		M59.3,144.5c3.4-3.8,5.1-8.7,5.1-14.8V46.3c0-6.1-1.7-11-5.1-14.8c-3.4-3.8-7.8-5.7-13.3-5.7c-5.5,0-9.8,1.9-13.1,5.7
	c-3.3,3.8-4.9,8.7-4.9,14.8v83.4c0,6.1,1.6,11.1,4.9,14.8c3.3,3.8,7.7,5.7,13.1,5.7C51.5,150.2,55.9,148.3,59.3,144.5"/>
			<path style={{
				fill: fontColor
			}} d="M191.1,170l-20.5-69.2c-0.3-0.6-0.7-1-1.2-1h-12.8c-0.8,0-1.2,0.4-1.2,1.2v68.5c0,0.8-0.3,1.5-0.8,2
	c-0.6,0.6-1.2,0.8-2,0.8h-22.2c-0.8,0-1.5-0.3-2-0.8c-0.6-0.6-0.8-1.2-0.8-2V6.5c0-0.8,0.3-1.5,0.8-2c0.6-0.6,1.2-0.8,2-0.8h45.3
	c8.5,0,16,2,22.5,6.1c6.5,4.1,11.6,9.9,15.2,17.4c3.6,7.5,5.4,16,5.4,25.7c0,10-1.9,18.6-5.8,25.8c-3.9,7.2-9.2,12.7-16.1,16.4
	c-0.6,0.2-0.9,0.6-0.7,1.4l23.6,72.6c0.2,0.3,0.2,0.7,0.2,1.2c0,1.4-0.9,2.2-2.7,2.2h-23.1C192.7,172.4,191.6,171.6,191.1,170
		M155.5,28.9v48c0,0.8,0.4,1.2,1.2,1.2h14.7c5.8,0,10.5-2.2,14.1-6.8c3.6-4.5,5.4-10.6,5.4-18.3c0-7.7-1.8-13.9-5.4-18.4
	c-3.6-4.6-8.3-6.9-14.1-6.9h-14.7C155.9,27.7,155.5,28.1,155.5,28.9"/>
			<path style={{
				fill: fontColor
			}} d="M251.5,171.5c-0.6-0.6-0.8-1.2-0.8-2V6.5c0-0.8,0.3-1.5,0.8-2c0.6-0.6,1.2-0.8,2-0.8h41.2c13.8,0,24.9,4.2,33.1,12.5
	c8.3,8.4,12.4,19.5,12.4,33.5v76.7c0,14-4.1,25.2-12.4,33.5c-8.3,8.4-19.3,12.5-33.1,12.5h-41.2
	C252.8,172.4,252.1,172.1,251.5,171.5 M279.9,148.3l14.5-0.2c5.3,0,9.6-2.1,12.9-6.4c3.3-4.3,5-9.9,5.2-17V51.4
	c0-7.2-1.6-13-4.9-17.2c-3.3-4.3-7.8-6.4-13.4-6.4h-14.2c-0.8,0-1.2,0.4-1.2,1.2v118.1C278.6,147.9,279,148.3,279.9,148.3"/>
			<path style={{
				fill: fontColor
			}} d="M458.8,26.9c-0.6,0.6-1.2,0.8-2,0.8h-52.1c-0.8,0-1.2,0.4-1.2,1.2v45.6c0,0.8,0.4,1.2,1.2,1.2h30.9c0.8,0,1.5,0.3,2,0.8
	c0.6,0.6,0.8,1.2,0.8,2v18.6c0,0.8-0.3,1.5-0.8,2.1c-0.6,0.6-1.2,0.8-2,0.8h-30.9c-0.8,0-1.2,0.4-1.2,1.2v45.8
	c0,0.8,0.4,1.2,1.2,1.2h52.1c0.8,0,1.5,0.3,2,0.8c0.6,0.6,0.8,1.2,0.8,2v18.3c0,0.8-0.3,1.5-0.8,2c-0.6,0.6-1.2,0.8-2,0.8h-78.3
	c-0.8,0-1.5-0.3-2.1-0.8c-0.6-0.6-0.8-1.2-0.8-2V6.5c0-0.8,0.3-1.5,0.8-2c0.6-0.6,1.2-0.8,2.1-0.8h78.3c0.8,0,1.5,0.3,2,0.8
	c0.6,0.6,0.8,1.2,0.8,2v18.3C459.7,25.7,459.4,26.3,458.8,26.9"/>
			<path style={{
				fill: fontColor
			}} d="M556.1,170l-20.5-69.2c-0.3-0.6-0.7-1-1.2-1h-12.8c-0.8,0-1.2,0.4-1.2,1.2v68.5c0,0.8-0.3,1.5-0.8,2
	c-0.6,0.6-1.2,0.8-2.1,0.8h-22.2c-0.8,0-1.5-0.3-2.1-0.8c-0.6-0.6-0.8-1.2-0.8-2V6.5c0-0.8,0.3-1.5,0.8-2c0.6-0.6,1.2-0.8,2.1-0.8
	h45.3c8.5,0,16,2,22.5,6.1c6.5,4.1,11.6,9.9,15.2,17.4c3.6,7.5,5.4,16,5.4,25.7c0,10-1.9,18.6-5.8,25.8
	c-3.9,7.2-9.2,12.7-16.1,16.4c-0.6,0.2-0.9,0.6-0.7,1.4l23.6,72.6c0.2,0.3,0.2,0.7,0.2,1.2c0,1.4-0.9,2.2-2.7,2.2h-23.1
	C557.6,172.4,556.6,171.6,556.1,170 M520.4,28.9v48c0,0.8,0.4,1.2,1.2,1.2h14.7c5.8,0,10.5-2.2,14.1-6.8c3.6-4.5,5.4-10.6,5.4-18.3
	c0-7.7-1.8-13.9-5.4-18.4c-3.6-4.6-8.3-6.9-14.1-6.9h-14.7C520.8,27.7,520.4,28.1,520.4,28.9"/>
			<path style={{
				fill: fontColor
			}} d="M682.9,169.7l-4.6-25.3c0-0.8-0.5-1.2-1.4-1.2h-35.2c-1,0-1.4,0.4-1.4,1.2l-4.6,25.3c-0.2,1.8-1.2,2.7-3.1,2.7h-21.9
	c-2.3,0-3.1-1-2.6-3.1L643.6,6.3c0.3-1.8,1.4-2.7,3.1-2.7h25.6c1.8,0,2.8,0.9,3.1,2.7l35.7,162.9v1c0,1.4-0.9,2.2-2.7,2.2H686
	C684.1,172.4,683,171.5,682.9,169.7 M645.8,121.3h26.8c1,0,1.4-0.4,1.2-1.2l-14-76.2c-0.2-0.5-0.4-0.7-0.7-0.7
	c-0.3,0-0.6,0.2-0.7,0.7l-13.7,76.2C644.4,120.9,644.8,121.3,645.8,121.3"/>
			<path style={{
				fill: fontColor
			}} d="M818.5,160.3c-8.6,8-19.8,12.1-33.6,12.1h-42.4c-0.8,0-1.5-0.3-2-0.8c-0.6-0.6-0.8-1.2-0.8-2V6.5c0-0.8,0.3-1.5,0.8-2
	c0.6-0.6,1.2-0.8,2-0.8h38.1c15.3,0,27.2,3.9,35.9,11.6c8.7,7.7,13,19,13,33.7c0,16.6-5.9,28.4-17.6,35.4c-0.8,0.5-1,1-0.5,1.4
	c6.3,4,11.2,9.4,14.7,16.2c3.5,6.8,5.3,14.8,5.3,24.1C831.4,140.9,827.1,152.3,818.5,160.3 M767.5,28.9v44.8c0,0.8,0.4,1.2,1.2,1.2
	H781c6.6,0,11.7-2,15.4-6c3.7-4,5.5-9.7,5.5-17.1c0-7.7-1.9-13.7-5.5-17.8c-3.7-4.2-8.8-6.3-15.4-6.3h-12.3
	C767.9,27.7,767.5,28.1,767.5,28.9 M797.9,141.3c3.7-4.5,5.5-10.8,5.5-19c0-8.4-1.9-14.9-5.5-19.6c-3.7-4.7-8.8-7.1-15.2-7.1h-14
	c-0.8,0-1.2,0.4-1.2,1.2v50.1c0,0.8,0.4,1.2,1.2,1.2h14C789.1,148,794.2,145.8,797.9,141.3"/>
			<path style={{
				fill: fontColor
			}} d="M863.8,171.5c-0.6-0.6-0.8-1.2-0.8-2V6.5c0-0.8,0.3-1.5,0.8-2c0.6-0.6,1.2-0.8,2-0.8H888c0.8,0,1.5,0.3,2,0.8
	c0.6,0.6,0.8,1.2,0.8,2v140.5c0,0.8,0.4,1.2,1.2,1.2h52.1c0.8,0,1.5,0.3,2.1,0.8c0.6,0.6,0.8,1.2,0.8,2v18.3c0,0.8-0.3,1.5-0.8,2
	c-0.6,0.6-1.2,0.8-2.1,0.8h-78.3C865,172.4,864.3,172.1,863.8,171.5"/>
			<path id="cross" style={{
				fill: crossColor
			}} d="M997,62.6h-25.7V36.9c0-1.7-1.4-3-3-3h-17.9c-1.7,0-3,1.4-3,3v25.7h-25.7c-1.7,0-3,1.4-3,3v17.9
	c0,1.7,1.4,3,3,3h25.7v25.7c0,1.7,1.4,3,3,3h17.9c1.7,0,3-1.4,3-3V86.5H997c1.7,0,3-1.4,3-3V65.6C1000,63.9,998.6,62.6,997,62.6"/>
		</svg>
	</div >
}